import React, { useState, useEffect, useMemo, Fragment } from 'react'
import { Modal, Form, Table, Button, Icon, Row, Col, Card, Input, DatePicker, Select, InputNumber, message, Tooltip } from 'antd'
import { cloneDeep } from 'lodash'
import { Decimal } from 'decimal.js'
import styles from './index.less'
import ProductModal from './ProductModal'
import ProductDetail from './ProductDetail'
import ComboModal from './ComboModal'
import ProductCategoryTreeSelect from "@/components/ProductCategoryTreeSelect"
import moment from 'moment'
import config from '@/utils/config'
import CustomerPicker from '@/components/CustomerPicker'
import ClinicUserPicker from '@/components/ClinicUserPicker'
import { queryClinicProduct, queryCategory } from '@/services/commodity'
import {
  HTTP_SUCCESS_CODE,
  PAY_METHODS,
  PAY_METHOD_DEPOSIT,
  ROLE_KEY,
  PAY_METHOD_PERIODIC_SETTLEMENT, PERIODS, PERIOD_CUSTOM, PRODUCT_CATEGORY_SERVICE, CLINIC_KEY,
  ORDER_SOURCE
} from '@/utils/consts'
import { queryClinicList } from '@/services/basicinfo'
import { queryEmployeesByClinicId } from '@/services/employee'
import { arrayToTree } from '@/utils/utils'
const { Option, OptGroup } = Select
const { storageKeys: { formLayoutKey }, formLayoutConfig } = config

let submitTimer = null
let okTimer = null
const productPageSize = 30
const QUANTITY_MAX = 1000

function disabledDate(current) {
  // Can not select days before today and today
  return current && current > moment().endOf('day')
}

/**
 * 计算订单项金额
 * @param price 价格
 * @param num 数量
 * @param discount 折扣
 * @return Number 订单项金额
 */
function calOrderItemSum(price, num, discount) {
  if (isNaN(price) || isNaN(num) || isNaN(discount)) return 0

  return new Decimal(price).mul(num).mul(discount).div(100).toFixed(2)
}

/**
 * 获取订单项item数据
 */
function getOrderItemData(item, isUpdate) {
  return {
    comment: item.comment,
    discount: +new Decimal(item.discount).div(100).toFixed(4),
    quantity: +item.quantity,
    productId: item.productId || item.product.id,
    actualAmount: item.actualAmount,
    discountPrice: item.discountAmount,
    realAmount: item.realAmount,
    couponPrice: new Decimal(item.discountAmount).minus(item.actualAmount).toFixed(2) > 0 ? new Decimal(item.discountAmount).minus(item.actualAmount).toFixed(2) : 0,
    id: isUpdate ? item.id : undefined,
    presetExecuteEmployeeId: item.presetExecuteEmployeeId,
    presetExecuteEmployeeName: item.presetExecuteEmployeeName
  }
}

//  判断数字
const regPos = /^\d+(\.\d+)?$/

// 产品选择下拉框
const ProductSelect = ({
  categoryId,
  value,
  onChange,
  clinicId,
}) => {
  const [loading, setLoading] = useState(false)
  const [products, setProducts] = useState([])

  useEffect(() => {
    if (categoryId) {
      fetchProduct({ categoryId, clinicId })
    } else {
      setProducts([])
    }
  }, [categoryId, clinicId])

  // 诊所变化时判断当前诊所是否存在某商品
  useEffect(() => {
    const product = products.find(_ => _.id === value)

    if (product && clinicId && product.clinicId !== clinicId) {
      onChange(undefined)
    }
  }, [clinicId])

  const fetchProduct = async ({ categoryId, clinicId, name = '' }) => {
    setLoading(true)
    const res = await queryClinicProduct({ categoryId, clinicId, pageNo: 1, pageSize: productPageSize, name, enable: true })
    setLoading(false)

    if (!res || res.code !== HTTP_SUCCESS_CODE) return

    setProducts(res.data.rows || [])
  }

  const handleSearch = (val) => {
    fetchProduct({ categoryId, clinicId, name: val })
  }

  const handleChange = (val) => {
    const product = products.find(_ => _.id === val)
    onChange(product)
  }

  const selectProps = {
    placeholder: "选择产品",
    allowClear: true,
    // showSearch: true,
    filterOption: false,
    dropdownMatchSelectWidth: false,
    value,
    loading,
    onChange: handleChange,
    onSearch: handleSearch,
    style: { minWidth: 150 },
    getPopupContainer: triggerNode => triggerNode.parentNode,
    notFoundContent: '诊所暂未添加选中分类的产品',
  }

  return (
    <Select {...selectProps}>
      {products.map(product => (
        <Option key={product.id} value={product.id}>{product.name}</Option>
      ))}
    </Select>
  )
}

const PersonalFormModal = ({ data, classification, onOk, onCancel, onSubmit, form, type, from, title, isSaving, isSubmit, currentUser, frequentEmployee = {}, ...modalProps }) => {
  const { getFieldDecorator, setFieldsValue, validateFields, getFieldValue, getFieldsValue, setFields } = form
  const [productVisible, setProductVisible] = useState(false)
  const [comboVisible, setComboVisible] = useState(false)
  const [productDetailVisible, setProductDetailVisible] = useState(false)
  const [productInfo, setProductInfo] = useState({})
  const [dataSource, setDataSource] = useState(() => [{ quantity: 1, discount: 100, }])
  const [layout, setLayout] = useState('compact')
  const [agencyTree, setAgencyTree] = useState([])
  const [categories, setCategories] = useState([])
  const [clinicUser, setClinicUser] = useState([])
  const [discount, setDiscount] = useState(1)
  const [orderDeduction, setOrderDeduction] = useState(0)
  const [disableConsultant, setDisableConsultant] = useState(false)
  const { clinicId, customerId, actualAmount } = getFieldsValue(['clinicId', 'customerId', 'discount', 'actualAmount'])
  const role = localStorage.getItem(ROLE_KEY)
  const rolePermissionVos = currentUser.rolePermissionVos || []
  const currentRole = rolePermissionVos.find(_ => _.roleId === +role)
  const isAssistant = currentRole && currentRole.name && currentRole.name.indexOf('在线医助') > -1
  const { consultant_doctor = [], personal_doctor = [], created_by = [], assistant_created_by = [], online_assistant = [], executor = [] } = frequentEmployee

  useEffect(() => {
    const cacheLayout = 'compact'
    if (cacheLayout && cacheLayout !== layout) {
      setLayout(cacheLayout)
    }

    queryClinicList({}).then((res) => {
      const { code, data } = res
      if (code === 0) {
        setAgencyTree(data)
      }
    })

    if (localStorage.getItem(CLINIC_KEY)) {
      queryEmployeesByClinicId({ clinic_id: localStorage.getItem(CLINIC_KEY) }).then((res) => {
        const { code, data } = res
        if (code === 0) {
          setClinicUser(data)
        }
      })
    }

    let { consultantDoctorId, personalDoctorId, assistantDoctorId, discount, clinicId, customerId, couponPrice, actualAmount, customerName, orderItemVos } = data

    if (!assistantDoctorId && isAssistant) {
      assistantDoctorId = currentUser.id
    }

    if (discount <= 1) {
      discount = discount
    } else {
      discount = 1
    }
    setDiscount(discount)
    setOrderDeduction(couponPrice)


    if (!clinicId) {
      clinicId = window.localStorage.getItem(CLINIC_KEY)
    }

    fetchClinicProductCategory(clinicId)

    customerId = customerId ? { customerName, customerId, clinicId, consultantDoctorId, personalDoctorId } : undefined
    setFieldsValue({
      consultantDoctorId,
      personalDoctorId,
      assistantDoctorId,
      clinicId: clinicId && Number(clinicId),
      customerId,
    }, () => {
      // 确保clinicId在订单项之前设置，否则会被清空
      if (!orderItemVos || !orderItemVos.length) return

      const dataSource = orderItemVos.map(item => {
        let { categoryList, product, quantity, discount, comment, actualAmount, discountPrice, presetExecuteEmployeeId } = item
        const productCategoryId = categoryList[categoryList.length - 1].id
        const amount = new Decimal(product.price).mul(quantity).toFixed(2)
        if (discount) {
          discount = discount * 100
        }
        // const discountAmount = calOrderItemSum(product.price, quantity, discount)

        return {
          productCategoryId,
          product,
          amount,
          quantity,
          discount: discount ? Number(discount).toFixed(2) : discount,
          comment,
          id: item.id,
          presetExecuteEmployeeId,  // 预设执行人
          discountAmount: discountPrice,
          actualAmount: actualAmount,
          realAmount: actualAmount
        }
      })

      setDataSource(dataSource)
    })
  }, [])

  // 客户发生变化
  useEffect(() => {
    if (customerId && customerId.clinicId) {
      setFieldsValue({ clinicId: Number(customerId.clinicId) })
      if (customerId.personalDoctorId) {
        setFieldsValue({ personalDoctorId: customerId.personalDoctorId })

      } else {
        setFieldsValue({ personalDoctorId: undefined })
        // setDisableConsultant(false)
      }
      if (customerId.consultantDoctorId) {
        setFieldsValue({ consultantDoctorId: customerId.consultantDoctorId })
        setDisableConsultant(true)
      } else {
        setDisableConsultant(false)
      }

      if (!isAssistant) {
        queryEmployeesByClinicId({ clinic_id: customerId.clinicId }).then((res) => {
          const { code, data } = res
          if (code === 0) {
            setClinicUser(data)
          }
        })
      }
    }
  }, [customerId])

  // 商品总金额
  const originAmount = useMemo(() => {

    if (!dataSource.length) return 0
    return dataSource.reduce((prev, current, index) => {
      const { product, quantity } = current
      if (product && quantity) {
        prev = prev.add(new Decimal(quantity).mul(new Decimal(product.price)))
      }

      return index === dataSource.length - 1 ? prev.toFixed(2) : prev
    }, new Decimal(0))
  }, [dataSource])

  // 订单总金额
  const amount = useMemo(() => {

    if (!dataSource.length) return 0

    return dataSource.reduce((prev, current, index) => {
      const { actualAmount } = current
      if (actualAmount && regPos.test(actualAmount)) {
        prev = prev.add(new Decimal(actualAmount))
      }

      return index === dataSource.length - 1 ? prev.toFixed(2) : prev
    }, new Decimal(0))
  }, [dataSource])

  // 订单总金额变化
  useEffect(() => {
    let a1 = new Decimal(0)
    dataSource.forEach((data, index) => {
      if (data.actualAmount && regPos.test(data.actualAmount)) {
        a1.add(data.actualAmount)
      }
    })

    // const actualAmount = new Decimal(amount).mul(discount).div(100).toFixed(2)
    let actualAmount = 0
    actualAmount = new Decimal(amount).toFixed(2)
    if (!orderDeduction)
      actualAmount = new Decimal(amount).toFixed(2)
    else
      actualAmount = new Decimal(amount).sub(orderDeduction).toFixed(2)
    setFieldsValue({ actualAmount })
  }, [amount])

  // 订单实际金额
  const discountAmount = useMemo(() => {
    let _amount = amount, _discount = discount

    if (isNaN(amount)) _amount = 0
    if (isNaN(discount)) _discount = 0

    return new Decimal(_amount).mul(_discount).div(100).toFixed(2)
  }, [amount, discount])

  useEffect(() => {
    if (amount === 0) {
      setDiscount(1)
      setOrderDeduction(0.00)
    } else if (actualAmount === 0) {
      setDiscount(0)
      setOrderDeduction(amount)
      setDataSource(prevDataSource => {
        let sum = 0
        let newData = prevDataSource.map(item => {

          item.realAmount = 0
          return item
        })
        return newData
      })
    } else if (amount > 0 && actualAmount > 0) {
      const discount = new Decimal(actualAmount).div(amount).toFixed(2)
      // setFieldsValue({discount})
      setDiscount(discount)

      const deduction = new Decimal(amount).sub(actualAmount).toFixed(2)

      setOrderDeduction(deduction)

      setDataSource(prevDataSource => {
        let sum = 0
        let newData = prevDataSource.map(item => {
          if (actualAmount > 0 && item.actualAmount) {
            item.realAmount = new Decimal(actualAmount).div(Decimal(amount)).mul(Decimal(item.actualAmount)).toFixed(2, Decimal.ROUND_DOWN)
            sum = new Decimal(item.realAmount).add(sum)
          } else {
            item.realAmount = 0
          }
          return item
        })
        newData[0].realAmount = new Decimal(actualAmount).sub(sum).add(newData[0].realAmount).toFixed(2)
        return newData
      })
    }
    if (actualAmount >= getFieldValue('riseAmount')) {
      setFields({
        riseAmount: {
          value: getFieldValue('riseAmount'),
          success: ''
        }
      })
    } else if (actualAmount && actualAmount < getFieldValue('riseAmount')) {
      setFields({
        riseAmount: {
          value: getFieldValue('riseAmount'),
          errors: [new Error('升单金额不能大于实收金额')]
        }
      })
    }
  }, [amount, actualAmount])

  // 折扣变化
  const handleDiscountChange = (discount) => {
    const actualAmount = new Decimal(amount).mul(discount).div(100).toFixed(2)

    // 订单实收价格变化
    setFieldsValue({ actualAmount })

    // 订单项实收价格变化
    const newDataSource = dataSource.map(item => {
      const { product, quantity } = item
      const price = (product || {}).price

      if (price > 0 && quantity > 0) {
        item.actualAmount = new Decimal(price).mul(quantity).mul(item.discount).div(100).mul(discount).div(100).toFixed(2)
      }
      return item
    })

    setDataSource(newDataSource)
  }

  // 优惠金额
  // const couponPrice = useMemo(() => {
  //   if (!amount || !actualAmount) return 0
  //   return new Decimal(discountAmount).minus(actualAmount)
  // }, [discountAmount, actualAmount])

  // 诊所变化
  const handleClinicIdChange = (clinicId) => {
    fetchClinicProductCategory(clinicId)
    const customerId = getFieldValue('customerId')
    const changedFields = { consultantDoctorId: undefined, personalDoctorId: undefined }

    // 如果选择的诊所与客户诊所(客户已经有诊所)不一致
    if (customerId && customerId.clinicId && customerId.clinicId !== clinicId) {
      //如果是在线医助 并且没有诊所 则不清空客户
      if (!(isAssistant && !data.clinicId)) {
        changedFields.customerId = undefined
      }
    }

    // 如果当前用户不是在线医助
    if (!isAssistant) {
      changedFields.assistantDoctorId = undefined
    }

    setFieldsValue(changedFields)

    if (!isAssistant) {
      if (clinicId) {
        //查询选择诊所员工
        queryEmployeesByClinicId({ clinic_id: clinicId }).then((res) => {
          const { code, data } = res
          if (code === 0) {
            setClinicUser(data)
            setFieldsValue({ createdBy: undefined })
          }
        })
      } else {
        setClinicUser([])
        setFieldsValue({ createdBy: undefined })
      }
    }
  }

  // 获取诊所产品类型
  const fetchClinicProductCategory = async () => {
    const res = await queryCategory({ pageNo: 1, pageSize: 100, typeList: ['service_product'] })

    if (!res || res.code !== HTTP_SUCCESS_CODE) return

    const tempData = (res.data.rows || []).map(_ => {
      return {
        title: _.name,
        key: _.id,
        id: _.id,
        value: _.id,
        pid: _.parentId
      }
    })
    const categories = arrayToTree(tempData)
    setCategories(categories)
  }

  const handleOk = () => {
    validateFields((errors, values) => {
      if (errors) return

      const validItems = dataSource.filter(item => !!item.product && item.quantity > 0)
      if (!validItems.length) {
        message.error('请至少添加一条订单项')
        return
      }
      if (okTimer !== null) {
        clearTimeout(okTimer)
      }
      okTimer = setTimeout(() => {
        if (type === 'add') {
          handleCreateOrder(validItems, values)
        } else {
          handleUpdateOrder(validItems, values)
        }
      }, 300)
    })
  }

  const handleSubmit = () => {
    validateFields((errors, values) => {
      if (errors) return

      const validItems = dataSource.filter(item => !!item.product && item.quantity)
      if (!validItems.length) {
        message.error('请至少添加一条订单项')
        return
      }


      const orderItemReqs = validItems.map(item => getOrderItemData(item, true))
      let { customerId, orderDate, payMethod, compactEndDate, period, days, ...other } = values
      customerId = customerId ? customerId.customerId : undefined
      orderDate = orderDate ? orderDate.format('YYYY-MM-DD') : undefined
      compactEndDate = compactEndDate ? compactEndDate.format('YYYY-MM-DD') : undefined
      if (payMethod === PAY_METHOD_PERIODIC_SETTLEMENT) {
        if (period === 'week') {
          days = 7
        } else if (period === 'month') {
          days = 30
        }
      }
      const params = {
        orderItemReqs,
        ...other,
        orderDate,
        compactEndDate,
        amount,
        originAmount,
        id: data.id,
        discount,
        // discountAmount,
        payMethod,
        period,
        days,
        customerId,
        couponPrice: orderDeduction,
        category: 'service',
        source: isAssistant ? ORDER_SOURCE['集团下单'] : ORDER_SOURCE['诊所下单']
        // creator:currentUser&&currentUser.id,
      }
      if (submitTimer !== null) {
        clearTimeout(submitTimer)
      }
      submitTimer = setTimeout(() => {
        onSubmit(params)
      }, 300)
    })
  }

  // 创建订单
  const handleCreateOrder = (validItems, values) => {
    const orderItemReqs = validItems.map(item => getOrderItemData(item, false))
    let { customerId, orderDate, payMethod, compactEndDate, period, days, ...other } = values
    orderDate = orderDate ? orderDate.format('YYYY-MM-DD') : undefined
    compactEndDate = compactEndDate ? compactEndDate.format('YYYY-MM-DD') : undefined
    customerId = customerId ? customerId.customerId : undefined
    if (payMethod === PAY_METHOD_PERIODIC_SETTLEMENT) {
      if (period === 'week') {
        days = 7
      } else if (period === 'month') {
        days = 30
      }
    }
    const params = {
      orderItemReqs,
      ...other,
      orderDate,
      compactEndDate,
      amount,
      originAmount,
      discount,
      // discountAmount,
      payMethod,
      period,
      days,
      customerId,
      couponPrice: orderDeduction,
      category: 'service'
    }
    onOk(type, params)
  }

  // 修改订单
  const handleUpdateOrder = (validItems, values) => {
    const orderItemReqs = validItems.map(item => getOrderItemData(item, false))
    let { customerId, orderDate, payMethod, compactEndDate, period, days, ...other } = values
    customerId = customerId ? customerId.customerId : undefined
    orderDate = orderDate ? orderDate.format('YYYY-MM-DD') : undefined
    compactEndDate = compactEndDate ? compactEndDate.format('YYYY-MM-DD') : undefined
    if (payMethod === PAY_METHOD_PERIODIC_SETTLEMENT) {
      if (period === 'week') {
        days = 7
      } else if (period === 'month') {
        days = 30
      }
    }
    const params = {
      orderItemReqs,
      ...other,
      orderDate,
      compactEndDate,
      amount,
      originAmount,
      id: data.id,
      discount,
      // discountAmount,
      payMethod,
      period,
      days,
      customerId,
      couponPrice: orderDeduction,
      category: 'service'
    }
    onOk(type, params)
  }

  const columns = [
    {
      dataIndex: 'productCategoryId',
      title: '商品类别',
      width: 160,
      render(productCategory, record, index) {
        return (
          <ProductCategoryTreeSelect
            productCategories={categories}
            value={productCategory}
            onChange={val => handleOrderChange('productCategoryId', val, index)}
          />
        )
      }
    },
    {
      key: 'productName',
      title: '商品名称',
      width: 200,
      render(_, record, index) {
        return (
          <ProductSelect
            clinicId={clinicId}
            categoryId={record.productCategoryId}
            value={(record.product || {}).id}
            onChange={val => handleOrderChange('product', val, index)}
          />
        )
      }
    },
    {
      key: 'productPrice',
      title: '商品定价',
      width: 100,
      align: 'center',
      render: (_, record) => record.product ? Number(record.product.price).toFixed(2) + '元' : undefined
    },
    {
      dataIndex: 'quantity',
      title: '数量',
      width: 100,
      align: 'center',
      render(text, record, index) {
        return (
          <InputNumber
            disabled={!record.product}
            min={1}
            max={QUANTITY_MAX}
            value={text}
            onChange={(e) => handleOrderChange('quantity', e, index)}
            style={{ width: 60 }}
          />
        )
      }
    },
    {
      dataIndex: 'discount',
      title: '折扣',
      width: 100,
      align: 'center',
      render(text, record, index) {
        return <InputNumber
          value={text}
          min={0}
          max={100}
          disabled={!record.product}
          style={{ width: 60 }}
          formatter={value => `${value}%`}
          parser={value => value.replace('%', '')}
          onChange={(val) => handleOrderChange('discount', val && regPos.test(val) ? Math.floor(val) : 100, index)}
        />
      }
    },
    {
      dataIndex: 'discountAmount',
      title: '折后金额',
      width: 120,
      align: 'right',
      render(discountAmount, record, index) {
        return (
          <Fragment>
            {/* <InputNumber
              style={{width: 90}}
              value={discountAmount}
              onChange={val => handleOrderChange('discountAmount', val, index)}
            /> */}
            {discountAmount}
            <span style={{ marginLeft: 4 }}>元</span>
          </Fragment>
        )
      }
    },
    {
      dataIndex: 'actualAmount',
      title: '折后立减',
      width: 100,
      align: 'right',
      render(actualAmount, record, index) {
        if (record.actualAmount >= 0 && regPos.test(record.actualAmount) && record.actualAmount >= 0 && record.discountAmount >= record.actualAmount) {
          let lijian = new Decimal(record.discountAmount).sub(record.actualAmount).toFixed(2)
          return (
            <Fragment>
              <span>{lijian}</span>
              <span style={{ marginLeft: 4 }}>元</span>
            </Fragment>
          )
        }
      }
    },
    // {
    //   dataIndex: 'deduction',
    //   title: '立减金额',
    //   align: 'right',
    //   render(deduction, record, index) {
    //     return (
    //       <Fragment>
    //         <InputNumber
    //           style={{width: 90}}
    //           value={deduction}
    //           onChange={val => handleOrderChange('deduction', val, index)}
    //         />
    //         <span style={{marginLeft: 4}}>元</span>
    //       </Fragment>
    //     )
    //   }
    // },
    {
      dataIndex: 'actualAmount',
      title: '单项收款',
      width: 140,
      align: 'center',
      render: (actualAmount, record, index) => {
        // if (!actualAmount) return null
        let orderItemCoupon = 0, orderCoupon = 0, title = ''

        // 订单项优惠
        if (record.product && record.quantity > 0 && record.discount > 0) {
          orderItemCoupon = new Decimal(record.product.price).mul(record.quantity).mul(100 - +record.discount).div(100).toFixed(2)
        }

        if (orderItemCoupon > 0) {
          title = `单项折扣${orderItemCoupon}元`
        }

        // if(regPos.test(record.actualAmount) && record.actualAmount >= 0 && record.discountAmount > record.actualAmount) {
        //   const lijian = new Decimal(record.discountAmount).sub(record.actualAmount)
        //   title = title ? `${title}，叠加单项立减${lijian}元` : `单项立减${lijian}元`
        // }

        const discount = getFieldValue('discount')

        if (discount < 100) {
          orderCoupon = new Decimal(record.discountAmount).mul(100 - discount).div(100).toFixed(2)
          title = title ? `${title}，叠加订单优惠${orderCoupon}元` : `订单优惠${orderCoupon}元`
        }

        const maxPrice = record.discountAmount

        if (!title)
          return (
            <Fragment>
              <InputNumber
                style={{ width: 80 }}
                value={actualAmount}
                disabled={!record.product}
                // min={0}
                // max={maxPrice}
                min={record.floorPrice}
                max={record.ceilingPrice}
                onChange={val => handleOrderChange('actualAmount', val, index)}
              /><span>元</span>
            </Fragment>
          )

        return (
          <Fragment>
            <InputNumber
              style={{ width: 80 }}
              value={actualAmount}
              disabled={!record.product}
              // min={0}
              // max={maxPrice}
              min={record.floorPrice}
              max={record.ceilingPrice}
              onChange={val => handleOrderChange('actualAmount', val, index)}
            /><span>元</span>
            <Tooltip title={title} getPopupContainer={triggerNode => triggerNode.parentNode}>
              <Icon type="question-circle" theme="twoTone" />
            </Tooltip>
          </Fragment>
        )
      }
    },
    {
      dataIndex: 'realAmount',
      title: '分摊实收明细',
      align: 'right',
      width: 100,
      render(realAmount, record, index) {
        return (
          <Fragment>
            {/* <InputNumber
              style={{width: 90}}
              value={discountAmount}
              onChange={val => handleOrderChange('discountAmount', val, index)}
            /> */}
            {realAmount}
            <span style={{ marginLeft: 4 }}>元</span>
          </Fragment>
        )
      }
    },
    {
      dataIndex: 'presetExecuteEmployeeId',
      title: '预设执行人',
      width: 120,
      render(text, record, index) {
        return (
          <Fragment>
            <Select
              allowClear={true}
              value={text}
              onChange={(e, option) => handleOrderChange('presetExecuteEmployee', option, index)}
              getPopupContainer={triggerNode => triggerNode.parentNode}
              showSearch
              filterOption={(input, option) => option.props.children.indexOf(input) >= 0}
            >
              <OptGroup label='常用人选'>
                {
                  executor.map(i => {
                    return <Option value={`${i.id}`}>{i.name}</Option>
                  })
                }
              </OptGroup>
              {
                clinicUser.map(item => <Option key={item.userId} shortId={item.id} value={item.id}>{item.name}</Option>)
              }
            </Select>
          </Fragment>
        )
      }
    },
    {
      dataIndex: 'comment',
      title: '备注',
      width: 180,
      align: 'center',
      render(comment, record, index) {
        return (
          <Input
            value={comment}
            style={{ width: 100 }}
            onChange={e => handleOrderChange('comment', e.target.value, index)}
          />
        )
      }
    },
    {
      dataIndex: 'operation',
      title: '操作',
      width: 60,
      align: 'center',
      render(text, record, index) {
        return <Fragment>
          <a href="javascript:void(0)" onClick={() => onDelect(index)}>删除</a>
        </Fragment>
      }
    }
  ]
  
  const formTitle = (
    <div className={styles.modalHeader}>
      <div className="modal-left">{title}</div>
      <div className="modal-right">
        <Tooltip title='保存后订单还可以修改/提交'>
          <Button
            type="primary"
            loading={isSaving}
            onClick={() => handleOk()}
            style={{ marginRight: 12 }}
          >
            <Icon type="save" /> 保存
          </Button>
        </Tooltip>
        <Tooltip title='提交后订单不能再修改'>
          <Button
            type="primary"
            style={{ marginRight: 12 }}
            onClick={() => handleSubmit()}
            loading={isSubmit}
          >
            <Icon type="to-top" /> 提交
          </Button>
        </Tooltip>
        <Button onClick={() => onCancel()}>取消</Button>
      </div>
    </div>
  )

  const onDelect = (index) => {
    setOrderDeduction(0)
    setDiscount(1)
    let newDataSource = cloneDeep(dataSource)
    newDataSource.splice(index, 1)
    // newDataSource.map(_ => _.realAmount = _.actualAmount)
    setDataSource([...newDataSource])
  }

  const handleOrderChange = (type, value, index) => {

    const newDataSource = dataSource.map((item, idx) => {
      if (idx !== index) return item

      if (type === 'quantity' && value > 0) {
        value = String(value).replace(/\.\d+$/, '')
        value = value > QUANTITY_MAX ? value.slice(0, String(QUANTITY_MAX).length) : value
        value = parseInt(value)

        item.floorPrice = item.defaultFloorPrice && (item.defaultFloorPrice * value).toFixed(2)
        item.ceilingPrice = item.defaultCeilingPrice && (item.defaultCeilingPrice * value).toFixed(2)
      }

      item[type] = value

      if (type === 'productCategoryId') {
        item.product = undefined
      }

      // 分类/产品/数量/折扣任一变化 actualAmount
      if (['product', 'productCategoryId', 'quantity', 'discount'].indexOf(type) > -1) {
        setOrderDeduction(0)
        let discountAmount = 0
        let amount = 0

        if (item.product && item.quantity > 0 && item.discount) {
          amount = new Decimal(item.product.price).mul(item.quantity).toFixed(2)

          if (item.discount > 0) {
            discountAmount = +new Decimal(amount).mul(item.discount).div(100).toFixed(2)
          }
        }

        item.amount = amount
        item.discountAmount = discountAmount
        item.realAmount = discountAmount

        const orderDiscount = getFieldValue('discount')
        let actualAmount = item.discountAmount

        if (orderDiscount > 0) {
          actualAmount = new Decimal(actualAmount).mul(orderDiscount).div(100).toFixed(2)
        }


        item.actualAmount = actualAmount
      }

      if (type === 'product') {
        //设置最高限价 最低限价
        item.floorPrice = value.floorPrice
        item.ceilingPrice = value.ceilingPrice
        //设置原始 最高限价 最低限价
        item.defaultFloorPrice = value.floorPrice
        item.defaultCeilingPrice = value.ceilingPrice
      }

      // 折扣价变化
      if (type === 'discountAmount') {
        let discount = 0

        if (item.discountAmount > 0 && item.product && item.quantity > 0) {
          discount = new Decimal(item.discountAmount).div(item.product.price).div(item.quantity).mul(100).toFixed(2)
        }

        item.discount = discount

        const orderDiscount = getFieldValue('discount')
        let actualAmount = item.discountAmount

        if (actualAmount > 0 && orderDiscount) {
          actualAmount = new Decimal(actualAmount).mul(orderDiscount).div(100).toFixed(2)
        }

        item.actualAmount = actualAmount
      }

      // 实际金额变化，已不允许修改，先保留，防止以后需要放开
      if (type === 'actualAmount' && regPos.test(value)) {
        setOrderDeduction(0)
        // let discount = 0

        // if (item.actualAmount > 0 && item.amount > 0) {
        //   discount = new Decimal(+item.actualAmount).div(+item.amount).mul(100).toFixed(4)
        // }

        // item.discount = discount
        item.actualAmount = value
        if (item.discountAmount) {
          item.deduction = new Decimal(item.discountAmount).sub(value).toFixed(2)
        }
        if (value === 0) {
          item.realAmount = 0
        }
        // if(item.product&&item.product.price){
        //   item.discount = new Decimal(value).div(new Decimal(item.quantity)).div(new Decimal(item.product.price)).mul(100).toFixed(2)
        // }

      }
      // 处理预设执行人
      if (type === 'presetExecuteEmployee') {
        const option = value.props
        item.presetExecuteEmployeeId = option.value
        item.presetExecuteEmployeeName = option.children
      }
      delete item.presetExecuteEmployee

      return item
    })
    setDataSource(newDataSource)
  }

  const onAddOrder = () => {
    let obj = {
      quantity: 1,
      discount: 100,
    }
    setDataSource([...dataSource, obj])
  }

  const productProps = {
    width: 900,
    visible: productVisible,
    title: '选择商品',
    maskClosable: true,
    closable: true,
    wrapClassName: 'vertical-center-modal',
    onOk: (orderItems) => {
      setDataSource(prevState => {
        const filteredItems = prevState.filter(_ => !!(_.product || {}).id)
        return orderItems.reduce((prev, current) => {
          const { categories, id, price } = current
          const index = prev.findIndex(_ => (_.product || {}).id === id)

          if (index > -1) {
            const item = prev[index]
            const quantity = (item.quantity || 0) + 1
            item.quantity = quantity
            item.amount = new Decimal(price).mul(quantity).toFixed(2)
            const discountAmount = calOrderItemSum(price, quantity, item.discount)
            item.discountAmount = discountAmount
            item.actualAmount = discountAmount

            item.floorPrice = item.defaultFloorPrice && item.defaultFloorPrice * quantity
            item.ceilingPrice = item.defaultCeilingPrice && item.defaultCeilingPrice * quantity
          } else {
            const quantity = 1, discount = 100
            const discountAmount = calOrderItemSum(price, quantity, discount)

            //设置最高限价 最低限价
            const floorPrice = current.floorPrice
            const ceilingPrice = current.ceilingPrice
            //设置原始 最高限价 最低限价
            const defaultFloorPrice = current.floorPrice
            const defaultCeilingPrice = current.ceilingPrice

            prev.push({
              productCategoryId: categories[categories.length - 1].id,
              product: current,
              quantity,
              discount,
              amount: new Decimal(price).mul(quantity).toFixed(2),
              discountAmount,
              actualAmount: discountAmount,
              floorPrice,
              ceilingPrice,
              defaultFloorPrice,
              defaultCeilingPrice
            })
          }

          return prev
        }, filteredItems)
      })
      setProductVisible(false)
    },
    onCancel: () => {
      setProductVisible(false)
    },
    onOpenDetail: (record) => {
      setProductDetailVisible(true)
      setProductInfo(record)
    },
    productCategories: categories,
    clinicId
  }
  const comboProps = {
    width: 1100,
    visible: comboVisible,
    title: '选择套餐',
    maskClosable: true,
    closable: true,
    wrapClassName: 'vertical-center-modal',
    onOk: (orderItems) => {
      setDataSource(prevState => {
        const filteredItems = prevState.filter(_ => !!(_.product || {}).id)
        return orderItems.reduce((prev, current) => {
          const { categoryList } = current
          const { id, price } = current.product
          const index = prev.findIndex(_ => (_.product || {}).id === id)

          if (index > -1) {
            const item = prev[index]
            const quantity = (item.quantity || 0) + current.quantity
            item.quantity = quantity
            item.amount = new Decimal(price).mul(quantity).toFixed(2)
            const discountAmount = calOrderItemSum(price, quantity, item.discount)
            item.discountAmount = discountAmount
            item.actualAmount = discountAmount
          } else {
            const quantity = current.quantity, discount = 100
            const discountAmount = calOrderItemSum(price, quantity, discount)

            prev.push({
              productCategoryId: categoryList[categoryList.length - 1].id,
              product: current.product,
              quantity,
              discount,
              amount: new Decimal(price).mul(quantity).toFixed(2),
              discountAmount,
              actualAmount: discountAmount
            })
          }

          return prev
        }, filteredItems)
      })
      setComboVisible(false)
    },
    onCancel: () => {
      setComboVisible(false)
    },
    productCategories: categories,
    clinicId
  }
  const productDetailProps = {
    width: 500,
    visible: productDetailVisible,
    title: `商品信息--${productInfo.name}`,
    maskClosable: false,
    footer: false,
    data: productInfo,
    wrapClassName: 'vertical-center-modal',
    onCancel: () => {
      setProductDetailVisible(false)
    }
  }

  const payMethod = getFieldValue('payMethod')
  const period = payMethod ? getFieldValue('period') : undefined

  // 升单金额效验
  const checkRiseAmount = (rule, value, callback) => {
    if (value && value > actualAmount) {
      callback('升单金额不能大于实收金额')
    } else {
      callback()
    }
  }

  return (
    <Modal
      {...modalProps}
      className={styles.modal}
      closable={false}
      title={formTitle}
    >
      <div className={styles.modalContent} id="modal-form">
        <div className={styles.modalForm}>
          <Form layout="horizontal">
            <Card size='small' title='基本概要'>
              <Row gutter={formLayoutConfig[layout].rowGutter}>
                <Col span={6}>
                  <Form.Item label="客户姓名" {...formLayoutConfig[layout].formItemLayout}>
                    {getFieldDecorator('customerId', {
                      rules: [
                        {
                          required: true,
                          message: '必填项'
                        },
                      ],
                    })(
                      <CustomerPicker
                        disabled={data.customerId}
                        size={formLayoutConfig[layout].formSize}
                        clinicId={clinicId}
                      />
                    )}
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item label='门店' {...formLayoutConfig[layout].formItemLayout}>
                    {getFieldDecorator('clinicId', {
                      initialValue: data.clinicId,
                      rules: [
                        {
                          required: true,
                          message: '必填项'
                        },
                      ],
                    })(
                      <Select
                        allowClear={true}
                        //如果当前是在线医助角色 并且没有诊所 可以修改诊所
                        disabled={(isAssistant && !data.clinicId) ? false : (clinicId || data.clinicId)}
                        size={formLayoutConfig[layout].formSize}
                        getPopupContainer={triggerNode => triggerNode.parentNode}
                        onChange={handleClinicIdChange}
                      >
                        {agencyTree && agencyTree.map(item =>
                          <Option key={item.id} value={item.id}>{item.shortName}</Option>)}
                      </Select>
                    )}
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item label='创建人' {...formLayoutConfig[layout].formItemLayout}>
                    {getFieldDecorator('creator')(<span>{currentUser.nickname}</span>)}
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item label='成单人' {...formLayoutConfig[layout].formItemLayout}>
                    {getFieldDecorator('createdBy', {
                      //在线医助下单，成单人，固定是在线医助姓名。不让选诊所员工。
                      initialValue: (isAssistant && !data.clinicId) ? (currentUser && currentUser.id) : (type === 'add' ? currentUser && currentUser.id : data.createdBy),
                      rules: [
                        {
                          required: true,
                          message: '必填项'
                        },
                      ],
                    })(
                      <Select
                        disabled={type !== 'add' || isAssistant}
                        allowClear={true}
                        size={formLayoutConfig[layout].formSize}
                        getPopupContainer={triggerNode => triggerNode.parentNode}
                        showSearch
                        filterOption={(input, option) => option.props.children.indexOf(input) >= 0}
                      >
                        <OptGroup label='常用人选'>
                          {
                            created_by.map(i => {
                              return <Option value={`${i.userId}`}>{i.name}</Option>
                            })
                          }
                        </OptGroup>
                        {isAssistant ? <Option key={currentUser && currentUser.id} value={currentUser && currentUser.id}>{currentUser && currentUser.nickname}</Option> : clinicUser && clinicUser.map(item =>
                          <Option key={item.userId} value={item.userId}>{item.name}</Option>)}
                      </Select>
                    )}
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item label='协助心理师' {...formLayoutConfig[layout].formItemLayout}>
                    {getFieldDecorator('assistantCreatedBy', {
                      initialValue: data.assistantCreatedBy
                    })(
                      <Select
                        allowClear={true}
                        size={formLayoutConfig[layout].formSize}
                        getPopupContainer={triggerNode => triggerNode.parentNode}
                        showSearch
                        filterOption={(input, option) => option.props.children.indexOf(input) >= 0}
                      >
                        <OptGroup label='常用人选'>
                          {
                            assistant_created_by.map(i => {
                              return <Option value={`${i.userId}`}>{i.name}</Option>
                            })
                          }
                        </OptGroup>
                        {
                          clinicUser.map(item => <Option key={item.userId} value={item.userId}>{item.name}</Option>)
                        }
                      </Select>
                    )}
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={formLayoutConfig[layout].rowGutter}>

                <Col span={formLayoutConfig[layout].colSpan}>
                  <Form.Item label="心理顾问" {...formLayoutConfig[layout].formItemLayout}>
                    {getFieldDecorator('consultantDoctorId', {
                      // initialValue: data.consultantDoctorId,
                      rules: [
                        // {
                        //   required: !!getFieldValue('riseAmount'),
                        //   message: '填写升单金额必须选择心理顾问'
                        // }
                        {
                          required: true,
                          message: '必填项'
                        },
                      ]
                    })(
                      <ClinicUserPicker
                        frequentList={consultant_doctor}
                        disabled={disableConsultant}
                        size={formLayoutConfig[layout].formSize}
                        clinicId={clinicId}
                        roleName='心理顾问'
                        from={'personal'}
                        modalType={from === 'order' ? 'add' : 'edit'}
                        initialValue={data.consultantDoctorId}
                      />
                    )}
                  </Form.Item>
                </Col>
                <Col span={formLayoutConfig[layout].colSpan}>
                  <Form.Item label="私人管家" {...formLayoutConfig[layout].formItemLayout}>
                    {getFieldDecorator('personalDoctorId', {
                      rules: [
                        {
                          required: true,
                          message: '必填项'
                        },
                      ],
                      // initialValue: data.personalDoctorId,
                    })(
                      <ClinicUserPicker
                        frequentList={personal_doctor}
                        size={formLayoutConfig[layout].formSize}
                        roleName='私人管家'
                        clinicId={clinicId}
                        from={'personal'}
                        modalType={from === 'order' ? 'add' : 'edit'}
                        initialValue={data.personalDoctorId}
                      />
                    )}
                  </Form.Item>
                </Col>
                <Col span={formLayoutConfig[layout].colSpan}>
                  <Form.Item label="下单日期" {...formLayoutConfig[layout].formItemLayout}>
                    {getFieldDecorator('orderDate', {
                      initialValue: data.orderDate ? moment(data.orderDate) : null,
                      rules: [
                        { required: true, message: '请选择下单日期' }
                      ]
                    })(
                      <DatePicker
                        getPopupContainer={triggerNode => triggerNode.parentNode}
                        size={formLayoutConfig[layout].formSize}
                        style={{ width: '100%' }}
                      // disabledDate={disabledDate}
                      />
                    )}
                  </Form.Item>
                </Col>
                <Col span={formLayoutConfig[layout].colSpan}>
                  <Form.Item label="合同服务截止日期" {...formLayoutConfig[layout].formItemLayout}>
                    {getFieldDecorator('compactEndDate', {
                      initialValue: data.compactEndDate ? moment(data.compactEndDate) : null,
                      // rules: [{ required: true, message: '请选择合同服务截止日期' }]
                    })(
                      <DatePicker
                        getPopupContainer={triggerNode => triggerNode.parentNode}
                        size={formLayoutConfig[layout].formSize}
                        style={{ width: '100%' }}
                      />
                    )}
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={formLayoutConfig[layout].rowGutter}>
                <Col span={formLayoutConfig[layout].colSpan}>
                  <Form.Item label="商品原价" {...formLayoutConfig[layout].formItemLayout}>
                    {getFieldDecorator('originAmount', {
                      // initialValue: data.weight,
                    })(
                      <span>{originAmount > -1 ? originAmount + "元" : originAmount}</span>
                    )}
                  </Form.Item>
                </Col>
                <Col span={formLayoutConfig[layout].colSpan}>
                  <Form.Item label="订单总金额" {...formLayoutConfig[layout].formItemLayout}>
                    {getFieldDecorator('amount', {
                      // initialValue: data.weight,
                    })(
                      <span>{amount > -1 ? amount + "元" : amount}</span>
                    )}
                  </Form.Item>
                </Col>
                <Col span={formLayoutConfig[layout].colSpan}>
                  <Form.Item label="订单整体折扣" {...formLayoutConfig[layout].formItemLayout}>
                    {/* {getFieldDecorator('discount', {
                      initialValue: data.discount ? data.discount * 100 : 100,
                    })(
                      <InputNumber
                        min={0}
                        max={100}
                        step={5}
                        formatter={value => `${value}%`}
                        parser={value => value.replace('%', '')}
                        size={formLayoutConfig[layout].formSize}
                        onChange={handleDiscountChange}
                      />
                    )} */}

                    {discount >= 0 ? `${(discount * 100).toFixed(2)}%` : `100%`}
                    {/* {amount > -1 ? `订单总金额${amount}元` : ''} */}
                    {orderDeduction ? ` 整体优惠 ${orderDeduction} 元` : ''}
                  </Form.Item>
                </Col>
                {/**<Col span={formLayoutConfig[layout].colSpan}>
                  <Form.Item label='订单实际金额' {...formLayoutConfig[layout].formItemLayout}>
                    {getFieldDecorator('discountAmount', {
                      // initialValue: data.birthday ? moment(data.birthday) : null,
                    })(
                      <span>{discountAmount > -1 ? discountAmount + "元" : discountAmount}</span>
                    )}
                  </Form.Item>
                </Col>
                 **/}
                <Col span={formLayoutConfig[layout].colSpan}>
                  <Form.Item label="订单应收金额" {...formLayoutConfig[layout].formItemLayout}>
                    {getFieldDecorator('actualAmount', {
                      initialValue: data.actualAmount,
                      rules: [
                        { required: true, message: '请填写订单应收金额' }
                      ]
                    })(
                      <InputNumber
                        precision={2}
                        size={formLayoutConfig[layout].formSize}
                        min={0}
                        max={amount}
                        style={{ width: 'calc(100% - 20px)' }}
                        disabled
                      />
                    )}<span style={{ marginLeft: 8 }}>元</span>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={formLayoutConfig[layout].rowGutter}>
                <Col span={formLayoutConfig[layout].colSpan}>
                  <Form.Item label='在线医助' {...formLayoutConfig[layout].formItemLayout}>
                    {getFieldDecorator('assistantDoctorId')(
                      <ClinicUserPicker
                        frequentList={online_assistant}
                        size={formLayoutConfig[layout].formSize}
                        clinicId={clinicId}
                        roleName='在线医助'
                        currentUser={isAssistant ? currentUser : undefined}
                      />
                    )}
                  </Form.Item>
                </Col>
                {/* <Col span={formLayoutConfig[layout].colSpan}>
                  <Form.Item label="升单金额" {...formLayoutConfig[layout].formItemLayout}>
                    {getFieldDecorator('riseAmount', {
                      initialValue: data.riseAmount,
                      rules: [
                        {
                          validator: (rule, value, callback) => checkRiseAmount(rule, value, callback),
                        }
                      ]
                    })(
                      <InputNumber size={formLayoutConfig[layout].formSize} min={0} />
                    )}<span style={{ marginLeft: 8 }}>元</span>
                  </Form.Item>
                </Col> */}
                <Col span={formLayoutConfig[layout].colSpan}>
                  <Form.Item label="升单备注" {...formLayoutConfig[layout].formItemLayout}>
                    {getFieldDecorator('riseReason', {
                      initialValue: data.riseReason
                    })(
                      <Input maxLength={100} size={formLayoutConfig[layout].formSize} />
                    )}
                  </Form.Item>
                </Col>
                {/* <Col span={formLayoutConfig[layout].colSpan}>
                  <Form.Item label="付费习惯" id="education" {...formLayoutConfig[layout].formItemLayout}>
                    {getFieldDecorator('payMethod', {
                      initialValue: data.payMethod,
                      // rules: [
                      //   {required: true, message: '请选择付费习惯'}
                      // ]
                    })(
                      <Select
                        size={formLayoutConfig[layout].formSize}
                        getPopupContainer={triggerNode => triggerNode.parentNode}
                      >
                        {PAY_METHODS.map(payMethod => (
                          <Option key={payMethod.value} value={payMethod.value}>{payMethod.name}</Option>
                        ))}
                      </Select>
                    )}
                  </Form.Item>
                </Col> */}
                {payMethod === PAY_METHOD_DEPOSIT &&
                  <Col span={formLayoutConfig[layout].colSpan}>
                    <Form.Item label="定金金额" {...formLayoutConfig[layout].formItemLayout}>
                      {getFieldDecorator('depositAmount', {
                        initialValue: data.depositAmount,
                        rules: [
                          { required: true, message: '请填写定金金额' }
                        ]
                      })(
                        <InputNumber size={formLayoutConfig[layout].formSize} min={1} />
                      )}<span style={{ marginLeft: 8 }}>元</span>
                    </Form.Item>
                  </Col>
                }
                {payMethod === PAY_METHOD_PERIODIC_SETTLEMENT &&
                  <Fragment>
                    <Col span={formLayoutConfig[layout].colSpan}>
                      <Form.Item label='周期' {...formLayoutConfig[layout].formItemLayout}>
                        {getFieldDecorator('period', {
                          initialValue: data.period,
                          rules: [
                            { required: true, message: '请选择周期' }
                          ]
                        })(
                          <Select size={formLayoutConfig[layout].formSize} getPopupContainer={triggerNode => triggerNode.parentNode}>
                            {PERIODS.map(option => (
                              <Option key={option.value} value={option.value}>{option.name}</Option>
                            ))}
                          </Select>
                        )}
                      </Form.Item>
                    </Col>
                    {period === PERIOD_CUSTOM &&
                      <Col span={formLayoutConfig[layout].colSpan}>
                        <Form.Item label='间隔天数' {...formLayoutConfig[layout].formItemLayout}>
                          {getFieldDecorator('days', {
                            initialValue: data.days,
                            rules: [
                              { required: true, message: '请填写天数' }
                            ]
                          })(
                            <InputNumber size={formLayoutConfig[layout].formSize} />
                          )}<span style={{ marginLeft: 8 }}>天</span>
                        </Form.Item>
                      </Col>
                    }
                    <Col span={formLayoutConfig[layout].colSpan}>
                      <Form.Item label='金额数目' {...formLayoutConfig[layout].formItemLayout}>
                        {getFieldDecorator('periodicSettlementAmount', {
                          initialValue: data.periodicSettlementAmount,
                        })(
                          <InputNumber size={formLayoutConfig[layout].formSize} />
                        )}<span style={{ marginLeft: 8 }}>元</span>
                      </Form.Item>
                    </Col>
                  </Fragment>
                }
              </Row>
              {/* <Row>
                <Col span={formLayoutConfig[layout].colSpan}>
                  <Form.Item label="商品总金额" {...formLayoutConfig[layout].formItemLayout}>
                    {getFieldDecorator('originAmount', {
                      // initialValue: data.weight,
                    })(
                      <span>{originAmount > -1 ? originAmount + "元" : originAmount}</span>
                    )}
                  </Form.Item>
                </Col>
              </Row> */}
            </Card>
            <Card size='small' style={{ marginTop: 20 }} title='订单明细' extra={
              <Row>
                <Button style={{ marginRight: 16 }} type='primary' onClick={() => setComboVisible(true)}>选择套餐</Button>
                <Button style={{ marginRight: 16 }} type='primary' onClick={() => { onAddOrder() }}>增加一行</Button>
                <Button type='primary' onClick={() => setProductVisible(true)}>批量添加</Button>
              </Row>
            }>
              <Table
                columns={columns}
                dataSource={dataSource}
                rowKey={(_, index) => index}
              // scroll={{x: 1300}}
              ></Table>
            </Card>
          </Form>
        </div>
        {comboVisible && <ComboModal {...comboProps} />}
        {productVisible && <ProductModal {...productProps} />}
        {productDetailVisible && <ProductDetail {...productDetailProps} />}
      </div>
    </Modal>
  )
}

export default Form.create()(PersonalFormModal)
